import type { Dispatch } from 'react';

import { ExportedPayoutsFilters } from './ExportedPayoutsFilters';
import type { FiltersState } from './localState';

type Props = {
  filters: FiltersState;
  setFilters: Dispatch<FiltersState>;
  resetState: Dispatch<void>;
};

export const ExportedPayoutsHeader = ({
  filters,
  setFilters,
  resetState
}: Props) => {
  return (
    <div className="w-full items-center">
      <div className="mb-6 flex h-10 w-full flex-row justify-between">
        <div className="text-2xl font-medium">Exported payouts</div>
      </div>
      <ExportedPayoutsFilters
        filters={filters}
        setFilters={setFilters}
        resetState={resetState}
      />
    </div>
  );
};
